import logo from './media/logo.svg';
import icon from './media/icon-homepage.png';
import './App.css';
import Communication from './modules/communication';
import Information from './modules/information';
import Entertainment from './modules/entertainment';
import DateTime from './modules/datetime';
import {initializeApp} from 'firebase/app';

//import firebase from 'firebase/compat/app'; 
 //    import 'firebase/compat/firestore';
//     import 'firebase/compat/auth'; 

//import { useAuthState } from 'react-firebase-hooks/auth';
//import { useCollectionData } from 'react-firebase-hooks/firestore';
const firebaseConfig = {
  apiKey: "AIzaSyDuateXHT6TxilckBfIY2KDc_QYkLAIGrU",
  authDomain: "nethome-5f88d.firebaseapp.com",
  databaseURL: "https://nethome-5f88d-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "nethome-5f88d",
  storageBucket: "nethome-5f88d.appspot.com",
  messagingSenderId: "711285107792",
  appId: "1:711285107792:web:a304db279b6a05a7bdf555",
  measurementId: "G-M4WCYVMSZK"
};
initializeApp(firebaseConfig);
//firebase.inititializeApp(firebaseConfig)
//const app = initializeApp(firebaseConfig);

//const auth = firebase.auth();
//const firestore = firebase.firestore();

function App() {
  return (
    <div className="App">
      <DateTime/>
      
      <header className="App-header">
        <img src={icon} className="App-icon" alt="logo" />
        <h1 translate="no" id="app_name_header">NetHome</h1>
      </header>
      
      <div class="links">
      <Communication/>
      <Information/>
      <Entertainment/>
      </div>
      
    </div>
  );
}

export default App;
